'use strict';

module.exports = function () {
    var element = document.getElementById('productpopup')
    if (!element) {
        return;
    }
    var popUp = {
        element: element,
        elementBackdrop: document.getElementById('popup_backdrop'),
        elementClose: document.getElementById('popup_close'),
        hasBeenPresented: false,
        options: {
            dateStart: element.dataset.dateStart,
            dateStop: element.dataset.dateStop,
            size: element.dataset.size,
            timeThreshold: element.dataset.time,
            scrollThreshold: element.dataset.scroll,
            clickThreshold: element.dataset.click,
            onExit: element.dataset.exit === "true"
        },

        // TODO: OR vs AND triggering
        try: function () {
            if (this.hasBeenPresented) {
                return;
            }

            this.present();
        },

        present: function () {
            this.elementBackdrop.style.display = 'block';
            this.element.style.display = 'block';
            this.element.classList.add('show');

            this.hasBeenPresented = true;

            var self = this;
            var closeIfClickedOutside = function (event) {
                if (event.target === self.element) {
                    self.close();

                    window.removeEventListener('click', closeIfClickedOutside);
                }
            }

            this.elementClose.addEventListener('click', function () {
                self.close();
            });

            window.addEventListener('click', closeIfClickedOutside);
        },

        close: function () {
            this.elementBackdrop.style.display = 'none';
            this.element.style.display = 'none';
            this.element.classList.remove('show');
        }
    };

    // TODO: On element ID
    if (popUp.options.timeThreshold) {
        setTimeout(function () {
            popUp.try();
        }, popUp.options.timeThreshold * 1000);
    }

    if (popUp.options.scrollThreshold) {
        var tryOnScroll = function () {
            var maxScroll = document.body.offsetHeight - window.innerHeight;
            var scrollPercentage = (window.scrollY / maxScroll) * 100;

            if (scrollPercentage >= popUp.options.scrollThreshold) {
                popUp.try();

                window.removeEventListener('scroll', tryOnScroll);
            }
        }

        window.addEventListener('scroll', tryOnScroll);
    }

    if (popUp.options.clickThreshold) {
        var clickCount = 0;
        var tryOnClick = function () {
            clickCount++;

            if (clickCount >= popUp.options.clickThreshold) {
                popUp.try();

                window.removeEventListener('click', tryOnClick);
            }
        }

        window.addEventListener('click', tryOnClick);
    }

    if (popUp.options.onExit) {
        var body = document.getElementsByTagName('body')[0];

        var tryOnExit = function (event) {
            popUp.try();

            body.addEventListener('mouseleave', tryOnExit);
        };

        body.addEventListener('mouseleave', tryOnExit);
    }
}